<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
import { Loading } from 'quasar'
import { mapActions, mapState } from 'vuex'
// import axios from 'axios'

export default {
  // data () {
  //   return {
  //     line: {
  //       displayName: 'LINE Username',
  //       pictureUrl: '../assets/profile.png',
  //       statusMessage: 'LINE Status Meassage',
  //       userId: 'U7e882d6b5bb641fa3f3bbc9c1f31b312'
  //     }
  //   }
  // },
  methods: {
    ...mapActions('auth', ['setLine', 'setRegister', 'authen'])
  },
  computed: {
    ...mapState('auth', ['activeRoute'])
  },
  mounted () {
    Loading.show()
    this.$liff.init({
      // liffId: process.env.LIFF_ID
      // Dev
      // liffId: '1655251669-py0gL72v'
      // UAT
      // liffId: '1654424252-pd342xZE'
      // Production
      liffId: '1655272735-48QGbMQV'
    }).then(() => {
      Loading.hide()
      if (this.$liff.isLoggedIn()) {
        this.$liff.getProfile().then(profile => {
          this.setLine(profile)
          this.authen()
          if (this.activeRoute !== null) {
            this.$router.push(this.activeRoute, () => {})
          } else {
            this.$router.push('/dashboard', () => {})
          }
        })
      } else {
        this.$liff.login()
      }
    })
  }

}
</script>

<style lang="scss">

@font-face {
  font-family: "Anuphan";
  src: url("assets/fonts/anuphan.woff2") format("woff2"),
    url("assets/fonts/anuphan.woff") format("woff");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Anuphan";
  src: url("assets/fonts/anuphan-medium.woff2") format("woff2"),
    url("assets/fonts/anuphan-medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Anuphan";
  src: url("assets/fonts/anuphan-bold.woff2") format("woff2"),
    url("assets/fonts/anuphan-bold.woff") format("woff");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

body {
  font-family: "Anuphan", "Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-weight: 300;
}
</style>
